import { Icon } from "PFComponents/icon";
import { useWindowSize } from "PFCore/helpers/use_window_size";
import PropTypes from "prop-types";

import css from "./footer.module.scss";

const RolePositionFooter = ({ isHotVisible, interestedIn }) => {
  const { windowWidth } = useWindowSize();
  return (
    <div className={css.wrapper}>
      {isHotVisible && (
        <div className={css.icons}>
          <Icon name="fire" size="md" color="paletteOrange0" />
          <div>&nbsp;{windowWidth > 320 ? "Hot - Lots of people are talking about this" : "Hot"}</div>
        </div>
      )}
      {interestedIn > 0 && <div className={css.right}>{`${interestedIn || 0} interested`}</div>}
    </div>
  );
};

RolePositionFooter.propTypes = {
  isHotVisible: PropTypes.bool,
  interestedIn: PropTypes.number
};

export default RolePositionFooter;
